import { type ClassSessionRecord } from '../../../../models/types';
import { type ClassSessionInfo, type ClassStudentGroup } from '../../context/types';
import { type RecordingStatus } from '../../types/recordingTypes';

export type Permission = 'PUBLIC' | 'ROSTER' | 'ADMINS';

export type RecordingRestrictionsGroup = {
    studentGroupId: number;
    lmsGroupType: 'group' | 'section';
    lmsGroupId: string;
};

export enum RecordingRestrictMode {
    Site = 'site', // Will defer to site settings.
    None = 'none',
    Session = 'session',
    Group = 'group'
}

export type RecordingRestrictionsRecord = {
    recording_uuid: string;
    class_uuid: string;
    mode: RecordingRestrictMode;
    lms_groups: RecordingRestrictionsGroup[];
    created_at: Date;
    updated_at: Date;
};

export type RecordingBulkPatchItem = {
    recordingId: string;
    name: string;
    permission: Permission;
    restrictBy?: RecordingRestrictMode;
    studentGroups?: number[];
};

export interface ClassRecording {
    recordingId: string;
    name: string;
    permission: Permission;
    status: RecordingStatus;
    when: string; // ISO date string
    duration: number; // Seconds
    session?: string;
    sessionPercent?: number;
    size: number; // Total bytes for all recording artifacts.
    restrictions?: RecordingRestrictionsRecord;
}
export interface SelectableItem {
    topic?: string | null;
    title: string;
    subTitle: string;
    text: string;
    start: string; // ISO date string
    end: string; //seconds
    type: string; //recording or session
    classUuid: string;
    sessionUuid: string;
    classGroups?: ClassStudentGroup[];
    sections?: ClassSessionInfo[];
    hasRecordings?: boolean;
}

export enum LmsType {
    Blackboard = 'blackboard',
    Canvas = 'canvas',
    CSOD = 'csod',
    D2l = 'd2l',
    Docebo = 'docebo',
    Moodle = 'moodle',
    OpenLms = 'openlms',
    Schoology = 'schoology',
    IMS = 'ims'
}

export enum LmsTypeCapitalized {
    Blackboard = 'Blackboard',
    Canvas = 'Canvas',
    CSOD = 'CSOD',
    D2l = 'D2L',
    Docebo = 'Docebo',
    Moodle = 'Moodle',
    OpenLms = 'OpenLMS',
    Schoology = 'Schoology',
    Test = 'TestLms',
    IMS = 'IMS'
}

export interface ClassRecordingFormFields {
    name: string;
    permission: Permission;
}

export interface ClassSessionWithRecording extends ClassSessionRecord {
    recordings?: ClassRecording[];
}
